import apiClient from "../../../utils/clients/axios";

export const KeyCreation = async (payload) => {
  const response = await apiClient.post("/keys/master-data/", payload, {});

  return response;
};

export const guestCreation = async (payload) => {
  const response = await apiClient.post(
    "/employee/",
    payload
  );

  return response;
};
